import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setGroup } from "../redux/actions";
import { ROUTES } from "../utils/constants";
import { updateStats } from "../utils/helpers";
import "./StartGame.css";
import "./FinalScene.css";

function FinalScene() {
	const dispatch = useDispatch();
	const group = useSelector((state) => state.group);

	useEffect(() => {
		if (!group) return;
		const finishedGroup = {
			...group,
			lastVisited: ROUTES.FINAL_SCENE,
			finished: true,
		};
		dispatch(setGroup(finishedGroup));
		updateStats(finishedGroup);
		// eslint-disable-next-line react-hooks/exhaustive-deps -- sincronizar cierre una vez al montar
	}, []);

	return (
		<div className="start-game-page start-game-page--welcome final-scene-page">
			<div className="start-game-inner final-scene-inner">
				<span className="start-game-badge">
					<span className="start-game-badge-dot" aria-hidden />
					Misión completada
				</span>

				<div className="start-game-panel final-scene-panel">
					<h1 className="start-game-title">
						¡Felicidades! Has conseguido{" "}
						<span className="start-game-title-accent">desbloquear el reto</span>
					</h1>
					<p className="start-game-lead">
						La unión de las inversiones ha permitido acceder a la información
						reservada sobre el futuro de COBEGA.
					</p>
				</div>
			</div>
		</div>
	);
}

export default FinalScene;
